import React from 'react'
import { IDividerProps } from './interface'

const Divider: React.FC<IDividerProps> = ({
  width = '100%',
  borderBottom = '1px solid #ebeef0',
  margin = '0',
  padding = '0',
}) => <div style={{ width, borderBottom, margin, padding }} />

export default Divider
